export default __webpack_public_path__ + "static/media/gallery_07.c51de1f1.jpg";